import { gql } from '@apollo/client';
import appraiserFieldsFragment from '../../AppraiserForm/queries/appraiserFieldsFragment';

const EDIT_CURRENT_APPRAISER = gql`
  mutation EditCurrentAppraiser($appraiser: CurrentAppraiserInput!) {
    editCurrentAppraiser(appraiser: $appraiser) {
      ...AppraiserFields
    }
  }
  ${appraiserFieldsFragment}
`;

export default EDIT_CURRENT_APPRAISER;
